import Deserializer from 'services/jsonapi-deserializer/deserializer';

/**
 * Instance of deserializer, for use with our assist JSON:API
 */
export const JSONAPIDeserializer = new Deserializer({
  id: 'entity_id',
  type: 'entity_type',
  keyFormat: (key): string => {
    // convert JSON:API _id & _type to normal id & type
    if (key === '_id') return 'id';
    if (key === '_type') return 'type';
    // otherwise don't process the key
    return key;
  }
});
